import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium } from '../../../../styles';

export const IndividualProjectsDrilldownStyles = css`
  ${MainStyles}

  :host {
    display: contents;
  }

  .individual-projects-drilldown {
    display: flex;
    width: 100%;
    gap: 10px;
    height: 100%;
    padding: 10px;
  }

  .project-drilldown-card {
    flex: 0 1 360px;
  }

  .project-header-card {
    display: flex;
    padding: 5px 0;
    flex-direction: column;
    width: 342px;
    border: 1px solid #2e3339;
    border-radius: 6px;
    height: 408px;
    margin-bottom: 16px;
    background-color: #15181b;
  }

  .project-header-card .header {
    padding-left: 10px;
    font-size: 18px;
    line-height: 40px;
    ${mixinRobotoBold}
  }

  .details-wrapper {
    display: flex;
    width: 100%;
    margin-top: 5px;
    padding: 10px 10px 5px;
    justify-content: space-between;
  }

  .details-wrapper > zero-button {
    background: none;
  }

  .project-name {
    color: #a9ff78;
    font-size: 18px;
    ${mixinRobotoMedium()}
  }

  .operational-status {
    width: 90px;
    display: flex;
    gap: 8px;
    justify-content: end;
  }

  .image-container {
    width: 100%;
    height: 162px;
    background-color: #1f2126;
    box-sizing: border-box;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }

  .company-name {
    color: #879ba6;
    font-size: 12px;
    line-height: 32px;
    ${mixinRobotoMedium()}
  }

  .favorite-icon {
    background-color: rgb(255 255 255 / 0%);
  }

  .project-description {
    color: #ccc;
    font-size: 12px;
    padding: 0 10px 10px;
  }

  .project-details-card {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .details-box {
    background-color: #15181b;
    width: 163px;
    height: 64px;
    border-radius: 6px;
    border: 1px solid #2e3339;
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
  }

  .info-title,
  .product-types-title,
  .location-header {
    width: 100%;
    color: #879ba6;
    font-size: 12px;
  }

  .product-types-card {
    background-color: rgb(21, 24, 27);
    width: 342px;
    height: 113px;
    border-radius: 6px;
    border: 1px solid rgb(46, 51, 57);
    padding: 2px 16px;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  .product-details {
    display: flex;
    justify-content: space-around;
    flex-grow: 2;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .location-card {
    border: 1px solid #2e3339;
    border-radius: 6px;
    width: 342px;
    background: #15181b;
  }

  .location {
    width: 100%;
    height: 200px;
    flex: 0 0 342;
    border-radius: 0 0 4px 4px;
  }

  .location-header h3 {
    padding-left: 16px;
  }

  .project-vppas-card {
    flex: 1 0 50%;
    display: flex;
    gap: 6px;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    width: auto;
  }

  .project-ranking-card {
    flex: 0 1 360px;
  }

  .auto-height {
    height: auto;
  }

  .graph-container {
    height: 100%;
  }
  .no-graph-container {
    display: flex;
    margin-top: 20%;
    align-self: center;
    color: darkgrey;
  }
`;
